import React, { useState } from "react";
import { trackEvent } from "../../utils/tracking";
import BookRepair from "../BookRepair/BookRepair";

/**
 * Floating quick-contact launcher — bottom-left (since WhatsApp float is bottom-right).
 * Expands to show: Call, SMS, WhatsApp, Book Repair.
 */
const QuickContact = () => {
  const [open, setOpen] = useState(false);
  const [showBooking, setShowBooking] = useState(false);

  const toggle = () => setOpen((o) => !o);

  return (
    <>
      {/* Main button + expand panel */}
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          zIndex: 999,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "12px",
        }}
      >
        {/* Expanded actions */}
        {open && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              animation: "qc-slide-up 0.2s ease",
            }}
          >
            {/* Book Repair */}
            <button
              onClick={() => {
                setShowBooking(true);
                setOpen(false);
              }}
              style={qcBtnStyle("#18305d", "#ffaa19")}
              aria-label="Book a repair"
            >
              <i className="fas fa-calendar-check" />
              <span>Book Repair</span>
            </button>

            {/* Call */}
            <a
              href="tel:+12159393933"
              onClick={() => trackEvent.phoneCall({ source: "quick_contact" })}
              style={qcBtnStyle("#28a745", "#fff")}
              aria-label="Call Cell Station"
            >
              <i className="fas fa-phone-alt" />
              <span>Call Now</span>
            </a>

            {/* SMS */}
            <a
              href="sms:+12159393933?body=Hi%20Cell%20Station!%20I%20need%20a%20repair%20quote."
              onClick={() => trackEvent.smsClick({ source: "quick_contact" })}
              style={qcBtnStyle("#6c757d", "#fff")}
              aria-label="Text Cell Station"
            >
              <i className="fas fa-comment-alt" />
              <span>Text Us</span>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/12159393933?text=Hi%20Cell%20Station!%20I%20need%20help%20with%20a%20repair."
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent.whatsappClick({ source: "quick_contact" })}
              style={qcBtnStyle("#25D366", "#fff")}
              aria-label="WhatsApp Cell Station"
            >
              <i className="fab fa-whatsapp" />
              <span>WhatsApp</span>
            </a>
          </div>
        )}

        {/* Launcher */}
        <button
          onClick={toggle}
          aria-label={open ? "Close quick contact" : "Open quick contact"}
          aria-expanded={open}
          style={{
            width: "58px",
            height: "58px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #F50963 0%, #c40851 100%)",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            boxShadow: "0 6px 20px rgba(245, 9, 99, 0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.35rem",
            transition: "transform 0.2s ease",
            transform: open ? "rotate(45deg)" : "rotate(0)",
          }}
        >
          <i className={`fas ${open ? "fa-times" : "fa-comments"}`} />
        </button>
      </div>

      {/* Keyframes */}
      <style>{`
        @keyframes qc-slide-up {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* Book Repair modal */}
      {showBooking && <BookRepair onClose={() => setShowBooking(false)} />}
    </>
  );
};

// Helper to keep button styles DRY
const qcBtnStyle = (bg, color) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px 18px",
  borderRadius: "26px",
  background: bg,
  color,
  textDecoration: "none",
  fontSize: "0.85rem",
  fontWeight: 700,
  boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
  border: "none",
  cursor: "pointer",
  whiteSpace: "nowrap",
  minWidth: "140px",
});

export default QuickContact;
